import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import WhatsAppButton from "../components/site/WhatsAppButton";
import { ArrowUpRight, Loader2 } from "lucide-react";

export default function PartnersIndex() {
  const navigate = useNavigate();
  const [partners, setPartners] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/partners").then(({ data }) => setPartners(data));
  }, []);

  return (
    <div className="grain">
      <Navbar />
      <main className="pt-[72px]">
        <section className="tech-grid border-b border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-signal" />
              <span className="font-mono text-[11px] tracking-[0.35em] uppercase text-signal">Sourcing Partners</span>
            </div>
            <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
              className="font-head font-black uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] text-white max-w-4xl">
              Global Tier-1 <span className="text-signal">Partners</span>
            </motion.h1>
            <p className="mt-6 text-slate-300 text-lg leading-relaxed max-w-2xl">
              We source precision motion components directly from the world's leading manufacturers. Explore each
              partner's live product catalog — auto-synced from their websites.
            </p>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          {!partners ? (
            <div className="py-20 text-center"><Loader2 className="w-8 h-8 animate-spin text-signal mx-auto" /></div>
          ) : (
            <div className="grid md:grid-cols-2 gap-6" data-testid="partners-grid">
              {partners.map((p, i) => (
                <motion.button key={p.slug} onClick={() => navigate(`/partners/${p.slug}`)} data-testid={`partner-card-${p.slug}`}
                  initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: (i % 2) * 0.08 }}
                  className="group text-left bg-card border border-white/10 hover:border-signal/50 transition-colors p-8 ticks">
                  <div className="flex items-start justify-between">
                    <div>
                      <h2 className="font-head font-black uppercase text-3xl text-white group-hover:text-signal transition-colors">{p.name}</h2>
                      <p className="font-mono text-[11px] uppercase tracking-wider text-signal mt-1">{p.tagline}</p>
                    </div>
                    <ArrowUpRight className="w-6 h-6 text-slate-500 group-hover:text-signal group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
                  </div>
                  <div className="flex flex-wrap gap-2 mt-6 font-mono text-[10px] uppercase tracking-wider text-slate-400">
                    <span className="border border-white/10 px-2 py-1">{p.product_count} products</span>
                    <span className="border border-white/10 px-2 py-1">{p.categories_count} categories</span>
                    {p.last_synced && <span className="border border-white/10 px-2 py-1 text-signal">Auto-synced</span>}
                  </div>
                </motion.button>
              ))}
            </div>
          )}
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
